import React from 'react'
import { Box, Container, Stack, Text } from '@mantine/core'
import { BRAND_COLOR, CTA_CONTENT } from '../utils/constants'

export default function CTA() {
  return (
    <Box
      py={{ base: 60, md: 100 }}
      style={{
        background: 'linear-gradient(180deg, #F5F7FA 0%, #E5E7EB 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container size="lg">
        <Box
          p={{ base: 'xl', md: 48 }}
          style={{
            borderRadius: '20px',
            background: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.08)',
            border: '1px solid rgba(255, 255, 255, 0.5)',
            textAlign: 'center',
          }}
        >
          <Stack gap="xl" align="center">
            <Box
              style={{
                display: 'inline-flex',
                padding: '8px 18px',
                borderRadius: '999px',
                backgroundColor: `${BRAND_COLOR}15`,
                border: `1px solid ${BRAND_COLOR}30`,
              }}
            >
              <Text size="sm" fw={500} c={BRAND_COLOR}>
                {CTA_CONTENT.badge}
              </Text>
            </Box>

            <Text
              size="2rem"
              fw={700}
              c="#1F2329"
              style={{
                lineHeight: 1.3,
                maxWidth: '700px',
              }}
            >
              {CTA_CONTENT.title}
            </Text>

            <Text
              size="md"
              c="#64748B"
              style={{
                lineHeight: 1.7,
                maxWidth: '600px',
              }}
            >
              {CTA_CONTENT.subtitle}
            </Text>
          </Stack>
        </Box>
      </Container>
    </Box>
  )
}
